// extracted by mini-css-extract-plugin
export default {"zateceno":"MfZateceno_zateceno__aCvSh"};